import React from 'react';

const SvgTakeTheCall = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 104 104"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M32.27 88.608V75.86c0-.703.569-1.272 1.271-1.272H70.18c.702 0 1.272.57 1.272 1.272v12.747c0 .702-.57 1.272-1.272 1.272H33.54c-.702 0-1.272-.57-1.272-1.272z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8D8D8D",
  d: "M46.645 80.135h10.431c.211 0 .382.171.382.382v3.435c0 .21-.17.381-.382.381H46.645a.382.382 0 01-.382-.381v-3.435c0-.211.17-.382.382-.382z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#BDBDBD",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M78.572 21.424c.652 0 1.19.491 1.263 1.124l.009.148v8.76c0 5.232-4.159 9.494-9.351 9.659l-.313.005v-2.546a7.12 7.12 0 007.114-6.84l.005-.28v-7.485H72.57v-2.545h6zM25.272 21.424c-.652 0-1.19.491-1.263 1.124l-.009.148v8.76c0 5.232 4.159 9.494 9.351 9.659l.313.005v-2.546a7.12 7.12 0 01-7.114-6.84l-.006-.28v-7.485h4.729v-2.545h-6z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M37.818 74.583v-3.718a4.81 4.81 0 014.81-4.81c2.656 0 3.41-2.153 3.41-4.809V59.39c0-4.27-3.092-6.966-6.104-9.991l-3.58-3.594c-5.304-5.329-5.484-13.94-5.484-21.458V15h41.98v9.347c0 7.518-.18 16.13-5.484 21.457l-3.58 3.594c-3.012 3.025-6.103 5.721-6.103 9.99v1.858c0 2.656.754 4.81 3.41 4.81a4.81 4.81 0 014.809 4.809v3.718H37.818z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50C871",
  d: "M48.96 15h8.905v10.003l-4.452-3.23-4.453 3.23z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  d: "M56.24 15h8.905v13.994l-4.452-3.23-4.453 3.23z"
})));

export default SvgTakeTheCall;